export const useTableHighlighting = (allowRowHighlighting: boolean, tableRef: React.MutableRefObject<HTMLDivElement>) => {
  const handleHighlightMouseOver = (rowNumber: number) => {
    if (!allowRowHighlighting || !tableRef.current) {
      return;
    }

    const allElementsWithRowNumber = Array.from(tableRef.current.querySelectorAll(`.row-${rowNumber}`)) as HTMLElement[];

    allElementsWithRowNumber.forEach((el) => {
      el.classList.add("hover");
    });
  };

  const handleHighlightMouseOut = (rowNumber: number) => {
    if (!allowRowHighlighting || !tableRef.current) {
      return;
    }

    const allElementsWithRowNumber = Array.from(tableRef.current.querySelectorAll(`.row-${rowNumber}`)) as HTMLElement[];

    allElementsWithRowNumber.forEach((el) => {
      el.classList.remove("hover");
    });
  };

  return {
    handleHighlightMouseOver,
    handleHighlightMouseOut,
  };
};
